export interface UserVO {
  id: string | null;
  username: string;
  firstName: string;
  lastName: string;
  roles?: Array<string>;
  // The push diagnostic conversation, returned on your own profile only, so clients can hide it.
  pushDiagnosticConversationSid?: string | null;
}

export class UserInitializer implements UserVO {
  firstName = "";
  id = null;
  lastName = "";
  username = "";
}
